import { useLPQuery } from '../lib/hooks/useLPQuery';
import type { TeamMembersUser } from '../lib/types/TeamMembersUser';

export type TeamMembersQueryParams = {
  sort?: {
    property: 'department' | 'organizationdomainId' | 'jobtitle' | 'name' | 'cyberiq';
    sortDirection: 1 | -1;
  };
  page?: {
    skip: number;
    take: number;
  };
  filters?: Filter[];
};

export type Filter = {
  property: string;
  operator: FilterOperator;
  value: string;
};

export enum FilterOperator {
  Undefined,
  Equals,
  NotEquals,
  LessThan,
  LessOrEqual,
  GreaterThan,
  GreaterOrEqual,
  Contains,
  NotContains,
  StartsWith,
  EndsWith,
  In,
  NotIn,
  ListContains,
  IsNull,
  IsNotNull,
}

export type TeamMembersQueryResponse = {
  total: number;
  skip: number | null;
  take: number | null;
  values: TeamMembersUser[];
};

export const useTeamMembersQuery = (params: TeamMembersQueryParams) => {
  return useLPQuery<TeamMembersQueryResponse>(['TeamMembersQuery', params], `/manager/teamLearners`, {}, undefined, {
    method: 'POST',
    json: params,
  });
};
